module.exports = __webpack_public_path__ + "static/media/moon.e41ef76c.jpeg";